import { render, staticRenderFns } from "./ResultToggler.vue?vue&type=template&id=a19775e4&"
import script from "./ResultToggler.vue?vue&type=script&lang=js&"
export * from "./ResultToggler.vue?vue&type=script&lang=js&"
import style0 from "./ResultToggler.vue?vue&type=style&index=0&id=a19775e4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports